import {Pipe, PipeTransform} from '@angular/core';
import {Days} from '../../supervision-management/compliance-items/compliance-item/enums/days.enum';

@Pipe({
    name: 'weekdayDisplay',
    pure: false
})
export class WeekdayDisplayPipe implements PipeTransform {
    constructor() {}

    transform(weekdayInterval: any): string {
        let retval: string = '';

        switch (Number(weekdayInterval)) {
            case Days.SUNDAY:
                retval = 'Sunday';
                break;

            case Days.MONDAY:
                retval = 'Monday';
                break;

            case Days.TUESDAY:
                retval = 'Tuesday';
                break;

            case Days.WEDNESDAY:
                retval = 'Wednesday';
                break;

            case Days.THURSDAY:
                retval = 'Thursday';
                break;

            case Days.FRIDAY:
                retval = 'Friday';
                break;

            case Days.SATURDAY:
                retval = 'Saturday';
                break;
        }

        return retval;
    }
}